import React from 'react';
import { useTranslation } from "react-i18next";
import { Modal } from 'reactstrap';

const LiveAlertModalExpiredPass = ({ userKind, live_info, isLiveAlertModalExpiredPass, handleSelectedFunc }) => {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isLiveAlertModalExpiredPass} centered  backdrop={false}>
            <div className="card container-fluid">
                <div className="card-body">
                    <div className="title-area text-center dark-grey-text">
                        <span>{t("클래스", { ns: "live" })} [</span>
                        <div className="title">
                            <span className="hiclass-text" title={live_info.liveName}><b>{live_info.liveName}</b></span>
                        </div>
                        <span>]{t("클래스_입장_안내_문구_1", { ns: "live" })}</span>
                    </div>
                    <div className="content-area dark-grey-text">
                        <div className="text-area text-center">
                            {
                                userKind === "hiclasstv" ?
                                    <span>
                                        {t("이용권_만료_안내_문구_1", { ns: "pass" })}<br />
                                        {t("이용권_만료_안내_문구_2", { ns: "pass" })}
                                    </span> :
                                    <span>
                                        {t("이용권_만료_안내_문구_1", { ns: "pass" })}<br />
                                        {t("이용권_만료_안내_문구_3", { ns: "pass" })}
                                    </span>
                            }
                        </div>
                    </div>
                    <button type="button" className="btn btn-md green white-text py-1 px-2" onClick={() => handleSelectedFunc({ selectedFunc: "LIVE_ALERT_TOGGLE" })}>{t("확인", { ns: "common" })}</button>
                </div>
            </div>
        </Modal>
    );
}

export default LiveAlertModalExpiredPass;